import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About the Book', path: '/about-the-book' },
    { name: 'About the Authors', path: '/about-the-authors' },
    { name: 'Media & Events', path: '/media-events' },
    { name: 'Order', path: '/buy' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        backgroundColor: '#FDFBF7',
        backgroundImage:
          'radial-gradient(85% 190% at 0% 50%, rgba(74,130,148,0.40), transparent 62%), radial-gradient(85% 190% at 100% 50%, rgba(226,150,48,0.46), transparent 62%)',
        boxShadow: isScrolled ? '0 2px 12px rgba(0, 0, 0, 0.08)' : 'none',
        transition: 'box-shadow 0.3s ease'
      }}
    >
      <nav
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '20px 40px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {/* Logo */}
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            fontFamily: 'var(--font-display)',
            fontSize: '1.5rem',
            fontWeight: '500',
            color: 'var(--color-black)',
            textDecoration: 'none'
          }}
        >
          <img
            src="/goldilocks-mark.png"
            alt="Goldilocks Zone"
            style={{
              height: '36px',
              width: 'auto',
              display: 'block'
            }}
          />
          The Goldilocks Zone
        </Link>

        {/* Desktop Navigation */}
        <ul
          style={{
            display: 'flex',
            listStyle: 'none',
            gap: '32px',
            margin: 0,
            padding: 0
          }}
          className="desktop-nav"
        >
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                style={{
                  color: isActive(link.path) ? '#1A1A1A' : '#1A1A1A',
                  fontWeight: isActive(link.path) ? '600' : '500',
                  fontSize: '0.95rem',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease, border-color 0.2s ease',
                  borderBottom: isActive(link.path) ? '2px solid #1A1A1A' : '2px solid transparent',
                  paddingBottom: '4px'
                }}
                onMouseEnter={(e) => {
                  if (!isActive(link.path)) {
                    e.target.style.color = '#000000';
                    e.target.style.borderBottom = '2px solid #1A1A1A';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive(link.path)) {
                    e.target.style.color = '#1A1A1A';
                    e.target.style.borderBottom = '2px solid transparent';
                  }
                }}
              >
                {link.name}
              </Link>
            </li>
          ))}
        </ul>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          style={{
            display: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px'
          }}
          className="mobile-menu-btn"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? (
            <X size={28} color="var(--color-black)" />
          ) : (
            <Menu size={28} color="var(--color-black)" />
          )}
        </button>
      </nav>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div
          style={{
            backgroundColor: '#FFFFFF',
            borderTop: '1px solid #E0E0E0',
            padding: '20px 40px'
          }}
          className="mobile-nav"
        >
          <ul
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              listStyle: 'none',
              margin: 0,
              padding: 0
            }}
          >
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  style={{
                    color: isActive(link.path) ? '#1A1A1A' : '#1A1A1A',
                    fontWeight: isActive(link.path) ? '600' : '500',
                    fontSize: '1.1rem',
                    textDecoration: 'none',
                    display: 'inline-block',
                    borderBottom: isActive(link.path) ? '2px solid #1A1A1A' : '2px solid transparent',
                    padding: '8px 0'
                  }}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      <style>{`
        @media (max-width: 1024px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
